
export default function Programas() {
  const programas = [
    {
      title: 'Formación Técnica Especializada',
      description: 'Capacitamos a personas en habilidades técnicas demandadas por el mercado laboral actual, desarrollando competencias específicas para sectores estratégicos.',
      image: 'https://static.readdy.ai/image/b286a2ed3ca10247dabf9d64ba360efd/48c57b9ff5219c485f8112eea2cd14af.jpeg'
    },
    {
      title: 'Desarrollo Empresarial',
      description: 'Fortalecimiento integral de MIPYMES mediante capacitación en gestión, administración y estrategias de crecimiento empresarial sostenible.',
      image: 'https://static.readdy.ai/image/b286a2ed3ca10247dabf9d64ba360efd/bf1127b0faf5166d2b4292793ca334b3.jpeg'
    },
    {
      title: 'Empleabilidad',
      description: 'Vinculación efectiva entre buscadores de empleo y empresas, facilitando oportunidades laborales y desarrollo del capital humano.',
      image: 'https://static.readdy.ai/image/b286a2ed3ca10247dabf9d64ba360efd/54f78e2addcd531273fff02d27b0b5c6.jpeg'
    }
  ];

  return (
    <section id="programas" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8 lg:px-16">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4 inline-flex items-center gap-3">
            Ejes de Trabajo
            <span className="text-4xl">🚀</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Iniciativas diseñadas para impulsar el crecimiento y desarrollo de las MIPYMES en el Valle de Sula
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {programas.map((programa, index) => (
            <div
              key={index}
              className="group relative rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:shadow-2xl"
            >
              <div className="relative h-96">
                <img
                  src={programa.image}
                  alt={programa.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>

                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="text-xl font-bold text-white mb-2">{programa.title}</h3>
                  <p className="text-white/90 text-sm mb-4 leading-relaxed">{programa.description}</p>
                  <div className="flex items-center justify-end">
                    <button className="text-white text-sm font-medium flex items-center space-x-1 hover:gap-2 transition-all whitespace-nowrap">
                      <span>Más información</span>
                      <i className="ri-arrow-right-line"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
